import { __rest } from 'tslib';
import React, { useState } from 'react';
import { styled, CommonStyles, Shape, Body } from '@teko/ds-foundation';

const ListContentWrapper = styled.div((props) => [
    CommonStyles,
    `
  background-color: ${props.theme.colors.white};
  padding: ${props.theme.spacing.s12} ${props.theme.spacing.s16};
  display: flex;
  align-items: center;
  position: relative;
  ${props.hover
        ? `
    background-color: ${props.theme.colors.background};
  `
        : ''}
  ${props.active && !props.hover
        ? `
      background-color: ${props.theme.colors.primary500};
      color: ${props.theme.colors.white};
      `
        : ''}
 ${props.hasDivider
        ? ` &:after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: ${props.theme.spacing.s16};
      bottom: 0;
      left: ${props.theme.spacing.s16};
      border-bottom: ${props.theme.borderWeight.m} solid ${props.theme.colors.divider};
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }`
        : ``}
`,
]);
const ListContent = (_a) => {
    var _b, _c;
    var { label, icon, hasDivider = false, active = false, onClick } = _a, rest = __rest(_a, ["label", "icon", "hasDivider", "active", "onClick"]);
    const [hover, setHover] = useState(false);
    return (React.createElement(ListContentWrapper, Object.assign({ onClick: () => {
            if (onClick)
                onClick();
        }, hasDivider: hasDivider, active: active, hover: hover, onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false) }, rest),
        icon && (React.createElement(Shape, { marginRight: "s12" }, React.cloneElement(icon, Object.assign({ size: !((_b = icon === null || icon === void 0 ? void 0 : icon.props) === null || _b === void 0 ? void 0 : _b.size) ? 24 : (_c = icon === null || icon === void 0 ? void 0 : icon.props) === null || _c === void 0 ? void 0 : _c.size }, (active && !hover ? { color: 'white' } : {}))))),
        React.createElement(Body, { level: 1, line: 1 }, label)));
};

export { ListContent as L };
